export const usersFrontend: TableModule = {
    name: "usersFrontend",
    route: "spa.settings.frontendUsers",
    defaultOrder: {
        column: "lastname|firstname",
        direction: "asc"
    },
    columns: [
        {
            name: "customName",
            sortable: true,
            pageLink: true,
            sortBy: "lastname|firstname",
            mobile: true,
            width: "w-1/2 sm:w-auto"
        },
        {
            name: "email",
            sortable: true
        },
        {
            name: "phone",
            breakpoint: "lg",
        },
        {
            name: "role_name",
        },
    ],
    filters: [
        {
            name: "id",
            column: "users.id",
            type: "numeric",
            reduced: '[,]'
        },
        {
            name: "firstname",
            column: "users.firstname",
            type: "string"
        },
        {
            name: "email",
            column: "users.email",
            type: "string",
            reduced: 'like'
        }
    ],
    tools: [
        // {
        //     name: "users.delete",
        //     color: "rose",
        //     icon: "heroicons:trash",
        //     ability:[
        //         "delete",
        //         "users"
        //     ]
        // },
        {
            name: "users.create",
            isCreateAction: true,
            ability: [
                "create",
                "users"
            ]
        }
    ]
}